export const state = {
  accessToken: '',
  isAuthenticated: false,
  username: '',
  user: null,
  sessionInfo: null,
};
